import React from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Modal from 'react-bootstrap/Modal';
import Organizations from './MaintenanceOrganizations';
import Personnel from './MaintenancePersonnel';
import Sites from './MaintenanceSites';
import Devices from './MaintenanceDevices';






const Maintenance = ({database, main_callback}) => {

    if (database) {

    //const organizations = database['organizations'];
    //var personnel = database['personnel'];
    //var sites = database['sites'];
    //var devices = database['devices'];

    console.log('Maintenance', database);

    return (
        <div>
            <h1>Maintenance</h1>

            <Tabs
                defaultActiveKey="organizations"
                id="maintenance-tabs"
                className="mb-3"
                fill
                >

                <Tab eventKey="organizations" title="Organizations">
                    <Organizations organizations={database['organizations']} main_callback={main_callback}/>
                </Tab>
                <Tab eventKey="personnel" title="Personnel">
                    {/* <Personnel personnel={personnel} main_callback={main_callback}/> */}
                    <Personnel database={database} main_callback={main_callback}/>
                </Tab>
                <Tab eventKey="sites" title="Sites">
                    <Sites database={database} main_callback={main_callback}/>
                </Tab>
                <Tab eventKey="devices" title="Devices">
                    <Devices database={database} main_callback={main_callback}/>
                </Tab>
            </Tabs>

            <p>Savcor 2024</p>
        </div>
 
    )

    }

}

export default Maintenance
